import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useHandleActionItem } from "../../../hooks/useHandleActionItem.js";
import InputText from "../../../components/forms/InputText.jsx";
import InputSwitch from "../../../components/forms/InputSwitch.jsx";
import { getApiUrl } from "../../../config/config.js";

const Toast = Swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.onmouseenter = Swal.stopTimer;
		toast.onmouseleave = Swal.resumeTimer;
	},
});

const reverseTranslateKeys = (data) => {
	const reverseMap = {
		Correo: "email",
		Nombre: "name",
		Teléfono: "phone",
		ID: "id",
		Creado: "createdAt",
		Contraseña: "password",
		Estado: "status",
		Admin: "admin",
	};

	const normalized = {};
	for (const key in data) {
		const normalizedKey = reverseMap[key] || key;
		// Convertir valores de string a boolean para status y admin
		if (normalizedKey === "status" || normalizedKey === "admin") {
			normalized[normalizedKey] = data[key] === true || data[key] === "true" || data[key] === 1 || data[key] === "1";
		} else {
			normalized[normalizedKey] = data[key];
		}
	}
	return normalized;
};

function AppIbUsersDetails() {
	const location = useLocation();
	const navigate = useNavigate();
	const locationType = location.state?.type || "";
	const data = useMemo(() => location.state?.data || [], [location.state?.data]);
	console.log("data", data);

	const [user, setUser] = useState({
		status: true, // Valor por defecto
		admin: false, // Valor por defecto
	});
	const { handleDelete, handleSubmit } = useHandleActionItem();

	useEffect(() => {
		if (locationType === "edit" && data) {
			setUser(reverseTranslateKeys(data));
		}
	}, [locationType, data]);

	const validateForm = () => {
		if (!user.name || !user.email || !user.phone) {
			Toast.fire({
				icon: "error",
				title: "Los campos obligatorios no pueden estar vacíos",
				background: "#1e2836",
			});
			return false;
		}
		return true;
	};

	const handleInputChange = (field, value) => {
		setUser((prev) => ({ ...prev, [field]: value }));
	};

	const handleSubmitForm = async (event) => {
		event.preventDefault();
		if (!validateForm()) return;
		try {
			// Preparar los datos para envío, asegurando que status y admin sean booleanos
			const userData = {
				...user,
				status: Boolean(user.status),
				admin: Boolean(user.admin),
			};

			if (locationType === "add") {
				console.log("URL:", getApiUrl() + "/register");
				const response = await fetch(getApiUrl() + "/register", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(userData),
				});
				const responseData = await response.json();
				if (responseData.ok) {
					Toast.fire({ icon: "success", title: responseData.message, background: "#1e2836", color: "#fff" });
					window.history.back();
					return;
				} else {
					Toast.fire({ icon: "error", title: responseData.message, background: "#1e2836", color: "#fff" });
				}
			} else {
				await handleSubmit("update", "users", userData);
			}
			navigate("/appIbUsers");
		} catch (error) {
			console.log("ERROR", error);
		}
	};

	const handleDeleteForm = async (event) => {
		event.preventDefault();
		console.log("TEST", { id: user.id }, "users", true);
		await handleDelete({ id: user.id }, "users", true);
	};

	return (
		<div>
			<form onSubmit={handleSubmitForm}>
				<h1 className="text-center">{locationType === "add" ? "Agregar Usuario" : "Actualizar Usuario"}</h1>
				<InputText label="Nombre" value={user.name || ""} setValue={(v) => handleInputChange("name", v)} />
				<InputText
					label="Correo"
					value={user.email || ""}
					setValue={(v) => handleInputChange("email", v)}
					disabled={locationType === "edit"}
				/>
				<InputText label="Teléfono" value={user.phone || ""} setValue={(v) => handleInputChange("phone", v)} />
				<InputText
					label="Contraseña"
					type="password"
					value={user.password || ""}
					setValue={(v) => handleInputChange("password", v)}
					disabled={locationType === "edit"}
				/>
				<InputSwitch label="Estado" value={user.status} setValue={(v) => handleInputChange("status", v)} />
				<InputSwitch label="Admin" value={user.admin} setValue={(v) => handleInputChange("admin", v)} />
				<hr />
				<div className="mb-3 d-flex justify-content-around ">
					<button type="submit" className="btn btn-outline-theme btn-lg">
						{locationType === "add" ? "Agregar" : "Actualizar"}
					</button>
					<button onClick={() => navigate("/appIbUsers")} className="btn btn-outline-theme btn-lg">
						Atrás
					</button>
					{locationType === "edit" && (
						<button onClick={handleDeleteForm} className="btn btn-outline-danger btn-lg">
							Eliminar
						</button>
					)}
				</div>
			</form>
		</div>
	);
}

export default AppIbUsersDetails;
